import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { GamesContext, IGamesContext } from '../../../../gamesState/gamesContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { games } = useContext<IGamesContext>(GamesContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const developerHeadingClasses = classNames(style.developer, style.heading);
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const applicationIdHeadingClasses = classNames(style.applicationId, style.heading);
	const versionCodeHeadingClasses = classNames(style.versionCode, style.heading);
	const versionNameHeadingClasses = classNames(style.versionName, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={developerHeadingClasses}
					translationNameSpace="listing"
					translationKey="developerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={applicationIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="applicationIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={versionCodeHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionCodeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={versionNameHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionNameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{games.games.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
